// Galea Home - eventos de interaccion personalizados.
// // Detecta clics/envios clave (WhatsApp, email, telefono, formulario de
// contacto, newsletter, apertura de desplegables de producto) y los
// reenvia via Shopify.analytics.publish() para que el Web Pixel
// personalizado los recoja y los envie a GA4.
// Este script NO envia nada directamente a ningun proveedor externo.
       (function () {
       function publish(eventName, payload) {
       try {
       if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
       window.Shopify.analytics.publish(eventName, payload || {});
       }
       } catch (e) {}
       }

       function closest(el, selector) {
       return el && el.closest ? el.closest(selector) : null;
       }

       document.addEventListener('click', function (event) {
       var target = event.target;

       var wa = closest(target, 'a[href*="wa.me"], a[href*="whatsapp.com"]');
       if (wa) {
       publish('whatsapp_click', { link_url: wa.href, page_path: window.location.pathname });
       return;
       }

       var mail = closest(target, 'a[href^="mailto:"]');
       if (mail) {
       publish('email_click', { link_url: mail.href, page_path: window.location.pathname });
       return;
       }

       var tel = closest(target, 'a[href^="tel:"]');
       if (tel) {
       publish('phone_click', { link_url: tel.href, page_path: window.location.pathname });
       return;
       }

       var accordionBtn = closest(target, '.Product__Tabs [data-action="toggle-collapsible"]');
       if (accordionBtn) {
       var label = accordionBtn.textContent.replace(/\s+/g, ' ').trim();
       publish('product_accordion_open', { label: label, page_path: window.location.pathname });
       return;
       }

       var newsletterBtn = closest(target, '#mc-embedded-subscribe');
       if (newsletterBtn) {
       publish('newsletter_signup', { page_path: window.location.pathname });
       return;
       }
       }, true);

       document.addEventListener('submit', function (event) {
       var form = event.target;
       if (form && form.id === 'contact_form') {
       publish('contact_form_submit', { page_path: window.location.pathname });
       }
       }, true);
       })();